<ng-container *transloco="let t; read 'home.calculator'">
  <ng-container *transloco="let g; read 'home.calculator.map'">
    <div class="flex flex-col gap-4 py-4 relative">
      <ng-container *ngIf="mapState === GoogleMapState.Initial">
        <div class="text-blue1 font-bold text-xl">
          1. {{ g('choose_location.title') }}
        </div>
        <psc-google-autocomplete
          (setAddress)="setAddress($event)"
          [(ngModel)]="addressValue"></psc-google-autocomplete>
        <psc-button
          [disabled]="!markerPosition"
          @inOutAnimation
          size="small"
          (buttonClicked)="confirmLocation()"
          [label]="g('choose_location.confirm_location')">
        </psc-button>
      </ng-container>
      <ng-container *ngIf="mapState !== GoogleMapState.Initial">
        <psc-button
          [disabled]="!markerPosition"
          @inOutAnimation
          size="small"
          (buttonClicked)="startFromBeginning()"
          [label]="g('start_from_beginning')">
        </psc-button>
      </ng-container>
      <ng-container *ngIf="mapState === GoogleMapState.LocationConfirmed">
        <div>
          <div class="text-blue1 font-bold text-xl">
            2. {{ g('location_chosen.title') }}:
          </div>
          <ul class="marker:text-blue2 flex flex-col gap-4">
            <li>{{ g('location_chosen.choice.input_manually') }}</li>
            <li>
              {{ g('location_chosen.choice.get_data_automatically') }}
              <psc-button
                class="ml-2"
                @inOutAnimation
                size="small"
                (buttonClicked)="getSolarData(markerPosition)"
                [label]="t('select')">
              </psc-button>
            </li>
            <li>
              {{ g('location_chosen.choice.select_roof') }}
              <psc-button
                class="ml-2"
                @inOutAnimation
                size="small"
                (buttonClicked)="startRoofSelection()"
                [label]="t('select')">
              </psc-button>
            </li>
          </ul>
        </div>
      </ng-container>
      <ng-container *ngIf="mapState === GoogleMapState.SolarApiFound">
        <div class="text-blue1 font-bold text-xl">
          3. {{ g('solar_data_found.title') }}
        </div>
        <psc-button
          @inOutAnimation
          size="small"
          (buttonClicked)="cancelSolarDataSelect()"
          [label]="g('back')">
        </psc-button>
      </ng-container>
      <ng-container *ngIf="mapState === GoogleMapState.SolarApiNotFound">
        <div class="text-blue1 font-bold text-xl">
          3. {{ g('solar_data_not_found.title') }}
        </div>
        <psc-button
          @inOutAnimation
          size="small"
          (buttonClicked)="mapState = GoogleMapState.LocationConfirmed"
          [label]="g('back')">
        </psc-button>
      </ng-container>
      <ng-container *ngIf="mapState === GoogleMapState.RoofSelection">
        <div class="text-blue1 font-bold text-xl">
          3. {{ g('select_roof.title') }}
        </div>
        <p class="text-sm text-gray-600">
          {{ g('draw_roof.instruction') }}
        </p>
        <psc-button
          [disabled]="!canFinishDrawing"
          @inOutAnimation
          size="small"
          (buttonClicked)="finishDrawing()"
          [label]="g('draw_roof.finish')">
        </psc-button>
        <psc-button
          @inOutAnimation
          size="small"
          (buttonClicked)="unselectRoof()"
          [label]="g('stop_roof_selection')">
        </psc-button>
      </ng-container>
      <ng-container
        *ngIf="mapState === GoogleMapState.RoofSelected">
        <div class="text-blue1 font-bold text-xl">
          4. {{ g('roof_selected.title') }}
        </div>
        <psc-button
          @inOutAnimation
          size="small"
          (buttonClicked)="unselectRoof()"
          [label]="g('roof_selected.unselect_roof')">
        </psc-button>
      </ng-container>
    </div>
    <div class="relative">
      <div class="absolute top-2 left-2 bg-white rounded-xl shadow-2xl z-10 px-6 py-4"
           *ngIf="buildingInsights">
        <ng-container *ngIf="selectedRoofSegment; else noSegmentSelected">
          <div class="text-xl">
            {{ g('selected_segment') }}
          </div>
          <div class="my-2 border-b border-gray-500"></div>
          <table class="table-auto">
            <tr>
              <td class="text-blue1 font-bold pr-2">{{ t('area.title') }}</td>
              <td>{{ selectedRoofSegment.stats.areaMeters2 }}</td>
            </tr>
            <tr>
              <td class="text-blue1 font-bold pr-2">{{ t('azimuth.title') }}</td>
              <td>{{ selectedRoofSegment.azimuthDegrees }}</td>
            </tr>
            <tr>
              <td class="text-blue1 font-bold pr-2">{{ t('tilt.title') }}</td>
              <td>{{ selectedRoofSegment.pitchDegrees }}</td>
            </tr>
          </table>
          <div class="flex gap-2 mt-4">
            <psc-button
              size="tiny"
              type="primary-blue-2"
              (buttonClicked)="selectCurrentSegment()"
              [label]="g('select_this_segment')"></psc-button>
            <psc-button
              size="tiny"
              type="secondary-magenta"
              (buttonClicked)="closeSegment()"
              [label]="g('cancel')"></psc-button>
          </div>
          <div class="text-gray-500 text-sm">
            *{{ g('select_fills_data') }}
          </div>
        </ng-container>
        <ng-template #noSegmentSelected>
          <div class="mb-3 text-xl">
            {{ g('select_roof_segment') }}
          </div>
        </ng-template>
      </div>
      <google-map
        height="700px"
        width="100%"
        [center]="center"
        [options]="mapOptions"
        [zoom]="mapZoom"
        (mapClick)="onMapClick($event.latLng?.toJSON())"
        (mapInitialized)="mapInitialized($event)">
        <map-marker *ngIf="markerPosition" [position]="markerPosition"></map-marker>
        <ng-container *ngFor="let marker of solarApiMarkers; let i = index">
          <map-marker
            [position]="marker.position!"
            [clickable]="true"
            [icon]="marker.icon!"
            (mapClick)="solarApiMarkerClicked(marker, i)"></map-marker>
        </ng-container>
      </google-map>
      <div class="absolute left-2 bottom-2 bg-white rounded-xl shadow-2xl p-4">
        <div class="mb-4 text-blue1 font-bold">
          {{ t('azimuth.title') }}
        </div>
        <div [style.transform]="'rotate('+orientation+'deg)'">
          <div class="long-arrow-right"></div>
        </div>
      </div>
      <div *ngIf="mapState === GoogleMapState.Initial"
           @inOutAnimation
           (click)="getUserLocation()"
           class="flex cursor-pointer rounded-[2px] bg-white hover:bg-gray-200 transition-all ease-in-out p-2 absolute bottom-[200px] right-[11px]">
        <mat-icon fontIcon="my_location" class="text-blue1"></mat-icon>
      </div>
    </div>
  </ng-container>
</ng-container>
